import { isProduction, formGraphQLUrl } from 'utils/url';
import type { ClientOptions } from 'graphql-ws';

import {
    getSocketConnectionParams,
    onSocketClosed,
    onSocketConnected,
    shouldRetrySocket,
    waitBeforeSocketRetry,
} from 'data/connection/socket-session';

import type { TypePolicies } from '@apollo/client';

export const LinkConfig: { uri: string } = {
    uri: formGraphQLUrl(false),
};

export const typePolicies: TypePolicies = {
    RequestedOrderProduct: { keyFields: ['orderId', '_id'] },
    OrderProduct: { keyFields: ['orderId', '_id'] },
    BoxProduct: { keyFields: ['boxId', '_id'] },
    User: {
        fields: {
            profile: {
                merge(existing: any, incoming: any) {
                    return { ...existing, ...incoming };
                },
            },
        },
    },
    Order: {
        fields: {
            stateHistory: {
                merge: false,
            },
            products: {
                merge: false,
            },
            price: {
                merge: false,
            },
        },
    },
    Query: {
        fields: {
            archivedOrders: {
                keyArgs: ['totemId'],
                merge(
                    existing: { archivedOrders: any[]; hasMore?: boolean } = { archivedOrders: [] },
                    incoming: { archivedOrders: any[]; hasMore?: boolean },
                    { readField }: { readField: (field: string, obj: any) => any },
                ) {
                    const newOrders: any[] = [];
                    const existingOrderIds = existing.archivedOrders.map((order) => readField('_id', order));
                    incoming.archivedOrders.forEach((item) => {
                        if (!existingOrderIds.includes(readField('_id', item))) {
                            newOrders.push(item);
                        }
                    });
                    return {
                        archivedOrders: [...existing.archivedOrders, ...newOrders],
                        hasMore: incoming.hasMore,
                    };
                },
            },
            getInvoices: {
                keyArgs: ['organizationId'],
                merge(
                    existing: { invoices: any[]; hasMore?: boolean } = { invoices: [] },
                    incoming: { invoices: any[]; hasMore?: boolean },
                    { readField }: { readField: (field: string, obj: any) => any },
                ) {
                    const newInvoices: any[] = [];
                    const existingInvoicesIds = existing.invoices.map((invoice) => readField('id', invoice));
                    incoming.invoices.forEach((item) => {
                        if (!existingInvoicesIds.includes(readField('id', item))) {
                            newInvoices.push(item);
                        }
                    });
                    return {
                        invoices: [...existing.invoices, ...newInvoices],
                        hasMore: incoming.hasMore,
                    };
                },
            },
        },
    },
};

export const ClientConfig: { connectToDevTools: boolean } = {
    connectToDevTools: !isProduction,
};

export const WSConfig: ClientOptions = {
    url: formGraphQLUrl(true),
    connectionParams: async () => ({
        token: (await getSocketConnectionParams()).token || '',
        // Ce client rafraîchit son token avant de rouvrir : l'API peut fermer la socket à l'échéance du token.
        refreshesToken: true,
        webapporigin: true,
    }),
    retryAttempts: Infinity,
    retryWait: waitBeforeSocketRetry,
    shouldRetry: shouldRetrySocket,
    on: {
        connected: onSocketConnected,
        closed: onSocketClosed,
    },
};
